<template>
  <div>
	<div class="form-group row">
		<div class="col-lg-5">
			<label for="">Cliente *</label>
			<input readonly ="text" v-model="ObjCliente.Nombre" class="form-control"/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2">
			<button type="button" class="btn btn-01 search mx-sm-3 mt-6" @click="GetCliente" data-toggle="modal" data-target="#ModalForm3"  data-backdrop="static">Buscar</button>
		</div>
		<div class="col-lg-5">
			<label for="">Propiedad *</label>
			<input readonly type="text" v-model="ObjPropiedad.Nombre" class="form-control"/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdClienteS" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
	</div>
	<div class="form-group row">
		<div class="col-lg-3">
			<label for="">Propuesta *</label>
			<select v-model="Venta.IdPropuesta" class="form-control" @change="ValoresPropuesta()">
				<option value="">Selecciona Propuesta</option>
				<option v-show="Venta.IdClienteS!=''" value="crear">Crear Propuesta</option>
				<option value="0">Sin Propuesta</option>
				<option v-for="(item,index) in ListaPropuestas" :value="item.IdPropuesta" :key="index">{{item.Numero}}</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdPropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2">
			<label for="">Tipo de Contrato *</label>
			<input  type="text" v-model="Venta.TipoContrato" class="form-control"/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TipoContrato" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2">
			<label for="">Tipo de Servicio *</label>
			<select :disabled="DisableCampos" v-model="Venta.IdConfigS" class="form-control" @change="GetTipoSer();SetCasillaSpendPlan()">
				<!-- <option value="">Selecciona un Tipo de Servicio</option> -->
				<option value="1">Mantenimiento</option>
				<option value="2">Servicio</option>
				<option value="3">Proyecto</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdConfigS" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-3">
			<label for="">Sub Tipo de Servicio *</label>
			<select v-model="Venta.IdTipoSer" class="form-control">
				<option value="">Selecciona Sub Tipo</option>
				<option v-for="(item,index) in ListaTipoSer" :value="item.IdTipoSer" :key="index">{{item.Concepto}}</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdTipoSer" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2">
			<label for="">Valor Propuesta *</label>
			<vue-numeric @paste="SugerenciaPegado" @input="SugerenciaVenta" :disabled="DisableCampos" class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="Venta.ValorPropuesta"></vue-numeric>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.ValorPropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
	</div>
	<div class="form-group row">
		<!-- <div class="col-lg-3">
			<label for="">Valor Propuesta *</label>
			<vue-numeric disabled class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="Venta.ValorPropuesta"></vue-numeric>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.ValorPropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div> -->
		<div class="col-lg-2">
			<label for="">Valor Venta</label>
			<vue-numeric class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="Venta.ValorVenta"></vue-numeric>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.ValorVenta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2">
			<label for="">Cantidad de Pagos *</label>
			<select @change="SetListaDetalles" v-model="Venta.NumPagos" class="form-control">
				<option value="">Número Pagos</option>
				<option value="1">1 Pago</option>
				<option value="2">2 Pagos</option>
				<option value="3">3 Pagos</option>
				<option value="4">4 Pagos</option>
				<option value="5">Estimados</option>
				<option value="6">Mensual</option>
				<option value="7">Bimestral</option>
				<option value="8">Trimestral</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NumPagos" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2" style="flex-basis:13%">
			<label for="">Venta *</label>
			<v-date-picker v-model="Venta.FechaVenta" :mode="typeCalendar"
				:popover="{
					placement: 'bottom',
					visibility: 'click'
				}"
				:input-props="{
					class: 'form-control cal-black',
					style: 'cursor:pointer;'
				}"
				:locale="'es-MX'"
			/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaVenta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2" style="flex-basis:13%">
			<label for="">Inicio*</label>
			<v-date-picker v-model="Venta.FechaInicio" :mode="typeCalendar"
				:popover="{
					placement: 'bottom',
					visibility: 'click'
				}"
				:input-props="{
					class: 'form-control cal-black',
					style: 'cursor:pointer;'
				}"
				:locale="'es-MX'"
			/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaInicio" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<div class="col-lg-2" style="flex-basis:13%">
			<label for="">Término*</label>
			<v-date-picker v-model="Venta.FechaTermino" :mode="typeCalendar"
				:popover="{
					placement: 'bottom',
					visibility: 'click'
				}"
				:input-props="{
					class: 'form-control cal-black',
					style: 'cursor:pointer;'
				}"
				:locale="'es-MX'"
			/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaTermino" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
		<!-- <div class="col-lg-3">
			<label>Documento de Confirmación</label>
			<div class="custom-file-input-image">
				<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
				<input type="text" v-model="NombreArchivo" class="form-control">
				<button type="button" class=""><i class="fas fa-paperclip"></i></button>
			</div>
		</div> -->
		<div class="col-lg-3">
			<label for="">Vendedor *</label>
			<select v-model="Venta.IdUsuario" class="form-control">
				<option value="">Selecciona Vendedor</option>
				<option v-for="(item,index) in ListaVendedores" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdUsuario" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div>
	</div>
	<div class="form-group row" v-if="Venta.NumPagos>0 && Venta.NumPagos<5">
		<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
			<div class="row">
				<div class="col-lg-5">
					<label for="">{{'Pago '+(index+1)}}</label>
					<vue-numeric @input="InputValorCopia(index)" class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
				</div>
				<div class="col-lg-7">
					<label for="">Tipo de Pago *</label>
					<select @change="SeleccionPago(index)" v-model="item.TipoPago" class="form-control">
						<option value="">Seleccione un Tipo de Pago</option>
						<option v-for="(jitem,jdex) in item.Lista" :key="jdex" :value="jitem.Valor">{{jitem.Label}}</option>
					</select>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row" v-else-if="Venta.NumPagos==5">
		<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
			<div class="row">
				<div class="col-lg-5">
					<label for="">{{'Pago '+(index+1)}}</label>
					<vue-numeric class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
				</div>
				<div class="col-lg-7">
					<label for="">Fecha Estimada</label>
					<v-date-picker v-model="item.FechaEstimada" :mode="typeCalendar"
						:popover="{
							placement: 'bottom',
							visibility: 'click'
						}"
						:input-props="{
							class: 'form-control cal-black',
							style: 'cursor:pointer;'
						}"
						:locale="'es-MX'"
					/>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row" v-else>
		<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
			<div class="row">
				<div class="col-lg-5">
					<label for="">{{'Pago'}}</label>
					<vue-numeric class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row">
		<div class="col-lg-2">
			<label>Gross Profit %</label>
        	<vue-numeric placeholder="0 %"  :minus="false" class="form-control"  currency="" separator="," :precision="0" v-model="Venta.GrossProfit"></vue-numeric>
        	<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.GrossProfit" :Mensaje="errorvalidacion.GrossProfit[0]"></Cvalidation></label>
		</div>
	</div>
	<div class="form-group row">
		<div class="col-lg-3">
			<label>Documento de Confirmación</label>
			<div class="custom-file-input-image">
				<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
				<input type="text" v-model="NombreArchivo" class="form-control">
				<button type="button" class=""><i class="fas fa-paperclip"></i></button>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="row pt-4">
				<div class="col-lg-4">
					<div class="form-check form-check-inline">
						<label class="check_box m-0 pl-4">
            				<input @change="LimpiarSpendPlan" :disabled="true" checked id="0" v-model="Venta.SpendPlan" value="1" type="radio" class="form-check-input">
            				<span class="checkmark" :style="Venta.SpendPlan==1 ? 'border:2px solid #bababa;background-color: #038ED9;' : 'border:2px solid #bababa;background-color: grey;'"></span>
            			</label>
						<span class="bold">Spend Plan Aut.</span>
					</div>
				</div>
				<div class="col-lg-4">
					<div class="form-check form-check-inline">
						<label class="check_box m-0 pl-4">
            				<input @change="LimpiarSpendPlan" :disabled="true" id="1" v-model="Venta.SpendPlan" value="2" type="radio" class="form-check-input">
            				<span class="checkmark" :style="Venta.SpendPlan==2 ? 'border:2px solid #bababa;background-color: #038ED9;' : 'border:2px solid #bababa;background-color: grey;'"></span>
            			</label>
						<span class="bold">Spend Plan Manual</span>
					</div>
				</div>
				<div class="col-lg-4" v-show="false">
					<div class="form-check form-check-inline">
						<label class="check_box m-0 pl-4">
            				<input v-model="Venta.ContratoMaster" type="checkbox" class="form-check-input">
            				<span class="checkmark" style="border:2px solid #bababa;"></span>
            			</label>
						<span class="bold">Contrato Master</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="col-lg-3" v-if="Venta.ContratoMaster && Venta.IdClienteS!=''"> -->
		<div class="col-lg-3" v-show="false">
			<label>Contrato Master</label>
			<select v-model="Venta.IdContratoMaster" class="form-control">
				<option value="">-Contrato-</option>
				<option v-for="(item,index) in ListaContratosMaster" :value="item.IdContrato" :key="index">{{item.NumeroC}}</option>
			</select>
		</div>
		<!-- <div class="col-lg-2">
			<label for="">Fecha de Término*</label>
			<v-date-picker v-model="Venta.FechaTermino" :mode="typeCalendar"
				:popover="{
					placement: 'bottom',
					visibility: 'click'
				}"
				:input-props="{
					class: 'form-control cal-black',
					style: 'cursor:pointer;'
				}"
				:locale="'es-MX'"
			/>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaTermino" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div> -->
		<!-- <div class="col-lg-4">
			<label for="">Vendedor *</label>
			<select v-model="Venta.IdUsuario" class="form-control">
				<option value="">Selecciona Un Vendedor</option>
				<option v-for="(item,index) in ListaVendedores" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
			</select>
			<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdUsuario" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
		</div> -->
	</div>
	<div class="form-group row">
		<div class="col-lg-12">
			<label for="">Comentarios del Contrato</label>
			<textarea v-model="Venta.Comentarios" cols="30" rows="4" class="form-control"></textarea>
		</div>
	</div>
	<div class="modal-footer f1-buttons mt-4 mx-0 px-0">
		<button :disabled="Venta.SpendPlan==''" v-if="Venta.IdVenta==0" @click="AbrirContrato(1)" data-toggle="modal" data-target="#Contrato" data-backdrop="static" type="button" class="btn btn-pink">
			<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
			<i class="fa fa-plus-circle"></i>
			Generar Contrato Automático
		</button>
		<button :disabled="Venta.SpendPlan==''" v-if="Venta.IdVenta==0" @click="AbrirContrato(2)" data-toggle="modal" data-target="#Contrato" data-backdrop="static" type="button" class="btn btn-primary">
			<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
			<i class="fa fa-plus-circle"></i>
			Generar Contrato Manual
		</button>
		<button v-else @click="Guardar" type="button" class="btn btn-01">
			<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
			<i class="fa fa-plus-circle"></i>
			Guardar
		</button>
	</div>
	<Ccliente :TipoModal='1'></Ccliente>
	<Modal :Showbutton="false" :NameModal="ConfigModalContrato.NameModal"  :size="ConfigModalContrato.Size"  :Nombre="ConfigModalContrato.Nombre"  :pEmitSeccion="ConfigModalContrato.EmitSeccion" :poBtnSave="ConfigModalContrato.oBtnSave">
		<template slot="Form">
			<Contrato></Contrato>
		</template>
	</Modal>
	<Modal :NameModal="ConfigModalSpendPlan.NameModal"  :size="ConfigModalSpendPlan.Size"  :Nombre="ConfigModalSpendPlan.Nombre"  :pEmitSeccion="ConfigModalSpendPlan.EmitSeccion" :poBtnSave="ConfigModalSpendPlan.oBtnSave">
		<template slot="Form">
			<SpendPlan :poBtnSave="ConfigModalSpendPlan.oBtnSave"></SpendPlan>
		</template>
	</Modal>
	<Modal :pEmitSeccion="ConfigModalPropuesta.EmitSeccion" :NameModal="ConfigModalPropuesta.NombreSeccion"  :size="ConfigModalPropuesta.Size" :Nombre="'Propuesta'" :poBtnSave="oBtnSavePropuesta">
    	<template slot="Form">
    	    <FormPropuesta :pOrigen="'ventas'" :pIdClienteS="Venta.IdClienteS" :NameList="ConfigModalPropuesta.NameForm" :poBtnSave="oBtnSavePropuesta">
    	    </FormPropuesta>
    	</template>
    </Modal>
  </div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue';
import Cvalidation from '@/components/Cvalidation.vue';
import Modal from '@/components/Cmodal.vue';
import Ccliente from '@/components/Ccliente.vue';
import Contrato from '../ventas/ContratoForm.vue';
import SpendPlan from '../ventas/SpendPlanForm.vue';
import FormPropuesta from '@/views/catalogos/propuestas/Form.vue';
export default {
name:'Form',
    props:["poBtnSave"],
    components:{
        Cbtnsave,
        Cvalidation,
        Modal,
		Ccliente,
		Contrato,
		SpendPlan,
		FormPropuesta
    },
	data() {
		return {
			Modal:true,
			FormName:'ventas',
			EmitSeccion:this.poBtnSave.EmitSeccion,
			NombreArchivo:'',
			Venta:{
				IdVenta:0,
				IdUsuario:'',
				IdPropuesta:'',
				IdCliente:'',
				IdClienteS:'',
				ValorPropuesta:'',
				ValorVenta:'',
				Archivo:'',
				IdConfigS:'',
				IdTipoSer:'',
				FechaVenta:'',
				NumPagos:'',
				FechaInicio:'',
				FechaTermino:'',
				Comentarios:'',
				Contrato:'',
				SpendPlan:'',
				IdCotizacionServicio:'',
				TipoContrato:'',
				ContratoMaster:false,
				IdContratoMaster:'',
				GrossProfit:''
			},
			ConfigModalContrato:{
				NameModal:'Contrato',
				Size:'modal-md',
				Nombre:'Contrato',
				EmitSeccion:'Contrato',
				oBtnSave:{
					isModal:true,
                    disableBtn:false,
                	toast:0,
                	nombreModal:"Contrato",
                	EmitSeccion:"Contrato"
				}
			},
			ConfigModalSpendPlan:{
				NameModal:'SpendPlan',
				Size:'modal-lg',
				Nombre:'Generar Spend Plan',
				EmitSeccion:'SpendPlan',
				oBtnSave:{
					isModal:true,
                    disableBtn:false,
                	toast:0,
                	nombreModal:"SpendPlan",
                	EmitSeccion:"SpendPlan"
				}
			},
			ConfigModalPropuesta:{
                NombreSeccion:"Propuesta",
                EmitSeccion:"Propuesta",
                Size:"modal-lg",
                Nombre:"Propuesta",
                NameForm:"Propuesta",
            },
			oBtnSavePropuesta:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Propuesta",
                EmitSeccion:"Propuesta"
            },
			ObjCliente:{},
			ObjPropiedad:{},
			ListaVendedores:[],
			ListaPropuestas:[],
			ListaTipoSer:[],
			errorvalidacion:[],
			ConfigLoad:{
				ShowLoader: false,
				ClassLoad:  true,
			},
			ListaDetalles:[],
			ListaDetallesCopia:[],
			SpendPlan:[],
			ListaContratosMaster:[],
			TipoContrato:0,
			GPPlanPorcent:0,
			DisableCampos:false
		}
	},
	methods: {
		async Guardar(){
			let FechaInicio='';
			if (this.Venta.FechaInicio !='' && this.Venta.FechaInicio!=undefined) {
				let day=this.Venta.FechaInicio.getDate();
                let month=this.Venta.FechaInicio.getMonth()+1;
                let year=this.Venta.FechaInicio.getFullYear();
                FechaInicio=year+'-'+month+'-'+day;
			}
			else{
				this.poBtnSave.disableBtn=false;
				this.ConfigLoad.ShowLoader = false;
				this.$toast.warning('Debe ingresar una fecha de inicio');
				this.bus.$emit('EnableBtnContrato');
				return false;
			}

			if (this.SpendPlan.length==0 && this.Venta.IdVenta==0) {
				this.$toast.warning('Aún no ha Guardado el Spend Plan');
				this.bus.$emit('EnableBtnContrato');
				return false;
			}
			this.poBtnSave.disableBtn=true;
			this.ConfigLoad.ShowLoader = true;
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			let FechaVenta='';
			let FechaTermino='';
			if (this.Venta.FechaVenta !='' && this.Venta.FechaVenta!=undefined) {
				let day=this.Venta.FechaVenta.getDate();
                let month=this.Venta.FechaVenta.getMonth()+1;
                let year=this.Venta.FechaVenta.getFullYear();
                FechaVenta=year+'-'+month+'-'+day;
			}
			if (this.Venta.FechaTermino !='' && this.Venta.FechaTermino!=undefined) {
				let day=this.Venta.FechaTermino.getDate();
                let month=this.Venta.FechaTermino.getMonth()+1;
                let year=this.Venta.FechaTermino.getFullYear();
                FechaTermino=year+'-'+month+'-'+day;
			}
			formData.set('IdVenta',this.Venta.IdVenta);
			formData.set('IdUsuario',this.Venta.IdUsuario);
			formData.set('IdPropuesta',this.Venta.IdPropuesta);
			formData.set('IdCliente',this.Venta.IdCliente);
			formData.set('IdClienteS',this.Venta.IdClienteS);
			formData.set('ValorPropuesta',this.Venta.ValorPropuesta);
			formData.set('ValorVenta',this.Venta.ValorVenta);
			formData.set('IdConfigS',this.Venta.IdConfigS);
			formData.set('IdTipoSer',this.Venta.IdTipoSer);
			formData.set('FechaVenta',FechaVenta);
			formData.set('FechaInicio',FechaInicio);
			formData.set('NumPagos',this.Venta.NumPagos);
			formData.set('FechaTermino',FechaTermino);
			formData.set('Comentarios',this.Venta.Comentarios);
			formData.set('Contrato',this.Venta.Contrato);
			formData.set('TipoContratoInsertar',this.Venta.TipoContrato);
			formData.set('ArchivoFile',this.Venta.Archivo);
			formData.set('SpendPlan',this.Venta.SpendPlan);
			formData.set('ContratoMaster',this.Venta.ContratoMaster ? 1 : 0);
			formData.set('IdContratoMaster',this.Venta.IdContratoMaster);
			formData.set('SpendPlanDetalle',JSON.stringify(this.SpendPlan));
			formData.set('TipoContrato',this.TipoContrato);
			formData.set('GPPlanPorcent',this.GPPlanPorcent);
			formData.set('GrossProfit',this.Venta.GrossProfit);
			if (this.Venta.NumPagos==5) {
				let Detalles=[];
				for (let i = 0; i < 6; i++) {
					if (this.ListaDetalles[i].FechaEstimada!='') {
						let FechaEstimada='';
						if (this.ListaDetalles[i].FechaEstimada !='' && this.ListaDetalles[i].FechaEstimada!=undefined) {
							let day=this.ListaDetalles[i].FechaEstimada.getDate();
            			    let month=this.ListaDetalles[i].FechaEstimada.getMonth()+1;
            			    let year=this.ListaDetalles[i].FechaEstimada.getFullYear();
            			    FechaEstimada=year+'-'+month+'-'+day;
							let Obj={Monto:this.ListaDetalles[i].Monto,FechaEstimada:FechaEstimada}
							Detalles.push(Obj);
						}
					}
					else{
						if (this.ListaDetalles[i].Monto!='' && this.ListaDetalles[i].Monto!='0') {
							this.poBtnSave.disableBtn=false;
							this.bus.$emit('EnableBtnContrato');
							this.$toast.warning('Favor de Colocar una Fecha Estimada');
							return false;	
						}
						let Obj={Monto:this.ListaDetalles[i].Monto,FechaEstimada:null}
						Detalles.push(Obj);
					}
				}
				formData.set('Detalles',JSON.stringify(Detalles));	
			}
			else{
				let EnArray=[1,2,3,4];
				if (EnArray.includes(this.Venta.NumPagos)) {
					let Bnd=false;
					this.ListaDetalles.forEach((value) => {
						if (value.TipoPago=='') {
							Bnd=true;
						}
					})
					if(Bnd){
						this.poBtnSave.disableBtn=false;
						this.bus.$emit('EnableBtnContrato');
						this.$toast.warning('Favor de Colocar un Tipo de Pago');
						return false;
					}	
				}
				formData.set('Detalles',JSON.stringify(this.ListaDetalles));
			}
			formData.set('NombreArchivoFile',image);
			// if (this.Venta.Archivo!="") {
            //     let index=this.Venta.Archivo.lastIndexOf("/")+1;
			// 	let cadena=this.Venta.Archivo.substr(index);
            //     formData.set('NombreArchivoFile','/'+cadena);
            // }
			await this.$http.post('ventas/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.bus.$emit('EnableBtnContrato');
				this.poBtnSave.disableBtn = false;
				this.$toast.success('Venta Guardada Correctamente');
				$('#ventas').modal('hide');
				$('#Contrato').modal('hide');
                this.bus.$emit('List');
			}).catch((err)=>{
				this.bus.$emit('EnableBtnContrato');
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			})
		},
		Limpiar(){
			$('#ventas > .modal-dialog > .modal-content > .modal-header > #exampleModalLabel').text('Ventas');
			this.ListaDetalles=[];
			this.ListaDetallesCopia=[];
            this.ListaVendedores=[];
			this.ListaPropuestas=[];
			this.ListaTipoSer=[];
			this.ListaContratosMaster=[];
			this.errorvalidacion=[];
			this.ObjCliente={};
			this.ObjPropiedad={};
            this.Venta={
                IdVenta:0,
				IdUsuario:'',
				IdPropuesta:'',
				IdCliente:'',
				IdClienteS:'',
				ValorPropuesta:'',
				ValorVenta:'',
				Archivo:'',
				IdConfigS:'',
				IdTipoSer:'',
				FechaVenta:'',
				FechaInicio:'',
				NumPagos:'',
				FechaTermino:'',
				Comentarios:'',
				Contrato:'',
				SpendPlan:'',
				IdCotizacionServicio:'',
				TipoContrato:'',
				ContratoMaster:false,
				IdContratoMaster:'',
				GrossProfit:''
            };
			this.NombreArchivo='Elegir archivo (0.5MB)';
        },
		ValoresPropuesta(){
			if (this.Venta.IdPropuesta=='0') {
				this.DisableCampos=false;
				this.Venta.IdCotizacionServicio='';
				this.SetCasillaSpendPlan();
				return false;
			}
			if (this.Venta.IdPropuesta=='crear') {
				$("#Propuesta").modal("show");
				this.bus.$emit('NewModal_'+this.ConfigModalPropuesta.EmitSeccion,0,0,this.ObjPropiedad,this.Venta.IdClienteS);
			}
			else{
				this.DisableCampos=true;
				let index=this.ListaPropuestas.findIndex((element)=>element.IdPropuesta==this.Venta.IdPropuesta);
				this.Venta.ValorPropuesta=this.ListaPropuestas[index].Valor;
				this.Venta.ValorVenta=this.ListaPropuestas[index].Valor;
				this.Venta.IdConfigS=this.ListaPropuestas[index].Tipo;
				this.Venta.IdCotizacionServicio=this.ListaPropuestas[index].IdCotizacionServicio;
				this.Venta.GrossProfit=this.ListaPropuestas[index].GrossProfit==null ? '' : this.ListaPropuestas[index].GrossProfit;
				this.Venta.Comentarios=this.ListaPropuestas[index].DescripcionPropuesta;
				if (this.ListaPropuestas[index].IdTipoSer!='') {
					this.Venta.IdTipoSer=this.ListaPropuestas[index].IdTipoSer;
				}
				this.GetTipoSer();
				this.SetCasillaSpendPlan();
			}
		},
		GetCliente(){
            this.bus.$emit('ListCcliente');
        },
		async get_one(){
			this.ConfigLoad.ShowLoader = true;
            await this.$http.get('ventas/recovery',{
                params:{
                    IdVenta:this.Venta.IdVenta
                }
            }).then((res)=>{
				const objres=res.data.data.venta;
				this.Venta.IdUsuario=objres.IdUsuario;
				this.Venta.IdPropuesta=objres.IdPropuesta;
				// console.log(this.Venta.IdPropuesta);
				this.Venta.IdCliente=objres.IdCliente;
				this.Venta.IdClienteS=objres.IdClienteS;
				this.Venta.ValorPropuesta=objres.ValorPropuesta;
				this.Venta.ValorVenta=objres.ValorVenta;
				this.Venta.Archivo=objres.Archivo;
				this.Venta.IdConfigS=objres.IdConfigS;
				this.Venta.IdTipoSer=objres.IdTipoSer;
				this.Venta.FechaVenta=objres.FechaVenta;
				this.Venta.NumPagos=objres.NumPagos;
				this.Venta.TiempoTermino=objres.TiempoTermino;
				this.Venta.TipoContrato=objres.TipoContrato;
				this.Venta.TipoTiempoTermino=objres.TipoTiempoTermino;
				this.Venta.Comentarios=objres.Comentarios;
				this.Venta.Contrato=objres.Contrato;
				this.Venta.GrossProfit=objres.GrossProfit;
				let formatedDate = objres.FechaVenta.replace(/-/g, "\/");
                this.Venta.FechaVenta=new Date(formatedDate);
				if (objres.FechaInicio!=null && objres.FechaInicio!='null' ) {
					let formatedDate3 = objres.FechaInicio.replace(/-/g, "\/");
                	this.Venta.FechaInicio=new Date(formatedDate3);	
				}
				let formatedDate2 = objres.FechaTermino.replace(/-/g, "\/");
                this.Venta.FechaTermino=new Date(formatedDate2);
				this.ListaDetalles=res.data.data.detalles;
				this.ObjCliente=res.data.data.cliente;
				this.ObjPropiedad=res.data.data.sucursal;
				this.Venta.SpendPlan=objres.SpendPlan;
				this.Venta.ContratoMaster=objres.ContratoMaster==0 || objres.ContratoMaster==null ? false : true;
				this.Venta.IdContratoMaster=objres.IdContratoMaster;
				this.NombreArchivo=objres.Archivo;
				$('#ventas > .modal-dialog > .modal-content > .modal-header > #exampleModalLabel').text(objres.NumeroC);
				if (this.Venta.NumPagos!=5) {
					for (let index = 0; index < this.ListaDetalles.length; index++) {
						this.ListaDetalles[index].Lista=[
							{Valor:'1',Label:'Anticipo'},
							{Valor:'2',Label:'Contado'},
							{Valor:'3',Label:'Contraentrega'},
							{Valor:'4',Label:'30 días'},
							{Valor:'5',Label:'60 días'},
							{Valor:'6',Label:'90 días'}
						];
					}	
				}
				else{
					for (let index = 0; index < 6; index++){
						if (typeof(this.ListaDetalles[index])==='undefined') {
							this.ListaDetalles.push({Monto:0,FechaEstimada:''})
						}
						else{
							let Fecha = this.ListaDetalles[index].FechaEstimada.replace(/-/g, "\/");
							this.ListaDetalles[index].FechaEstimada=new Date(Fecha);
						}
					}
				}
				this.ListaDetallesCopia=this.ListaDetalles;
			}).finally(()=>{
				// console.log(this.Venta.IdPropuesta);
				this.GetTipoSer();
				this.GetPropuestas();
				this.GetContratosMaster();
				this.ConfigLoad.ShowLoader = false;
			});
		},
		async GetTipoSer(){
			await this.$http.get('tiposervicio/get',{
				params:{
					RegEstatus:'A',
					IdConfigS:this.Venta.IdConfigS,
					// IdTipoServ:this.contract.IdTipoServ,
					Entrada:''
				}
			}).then( (res) => {
				this.ListaTipoSer=res.data.data.tiposervicio;
			});
		},
		async GetVendedor(){
			await this.$http.get('vendedores/get', {
                params: { RegEstatus: "A",Admin:1 },
            })
            .then((res) => {
                let Mapeado=res.data.data.Vendedores.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaVendedores=Mapeado;
            });
		},
		async GetPropuestas(Propuesta=null){
			await this.$http.get('propuestas/get',{
				params:{
					RegEstatus:'A',
					IdClienteS:this.Venta.IdClienteS,
					Estatus:this.Venta.IdVenta==0 ? 'Activa' : ''
				}
			}).then((res)=>{
				this.ListaPropuestas=res.data.data.todos;
				// console.log(this.Venta.IdPropuesta);
			}).finally(()=>{
				if (Propuesta!=null) {
					this.ValoresPropuesta();
				}
			})
		},
		SeleccionarCliente(oSucursal,oCliente){
			this.Venta.ValorPropuesta='';
			this.Venta.ValorVenta='';
			this.Venta.IdConfigS='';
			this.Venta.IdTipoSer='';
			this.Venta.IdPropuesta='';
			this.Venta.GrossProfit='';
			this.ObjCliente=oCliente;
			this.ObjPropiedad=oSucursal;
			this.Venta.IdCliente=oCliente.IdCliente;
			this.Venta.IdClienteS=oSucursal.IdClienteS;
			this.GetPropuestas();
			this.GetContratosMaster();
		},
		GenerarSpendPlan(){
			this.bus.$emit('NewModal_'+this.ConfigModalSpendPlan.EmitSeccion,this.Venta.IdCotizacionServicio,this.SpendPlan,this.Venta.SpendPlan);
		},
		SetListaDetalles(){
			this.ListaDetalles=[];
			this.ListaDetallesCopia=[];
			if (this.Venta.NumPagos<5) {
				let Veces=parseInt(this.Venta.NumPagos);
				for (let index = 0; index < Veces; index++) {
					if (Veces==1) {
						this.ListaDetalles.push({Monto:this.Venta.ValorVenta,TipoPago:'',Lista:[
								{Valor:'1',Label:'Anticipo'},
								{Valor:'3',Label:'Contraentrega'},
								{Valor:'4',Label:'30 días'},
								{Valor:'5',Label:'60 días'},
								{Valor:'6',Label:'90 días'}
							]});
							this.ListaDetallesCopia.push({Monto:this.Venta.ValorVenta,TipoPago:'',Lista:[
								{Valor:'1',Label:'Anticipo'},
								{Valor:'3',Label:'Contraentrega'},
								{Valor:'4',Label:'30 días'},
								{Valor:'5',Label:'60 días'},
								{Valor:'6',Label:'90 días'}
							]});
					}
					else{
						this.ListaDetalles.push({Monto:0,TipoPago:'',Lista:[
							{Valor:'1',Label:'Anticipo'},
							{Valor:'3',Label:'Contraentrega'},
							{Valor:'4',Label:'30 días'},
							{Valor:'5',Label:'60 días'},
							{Valor:'6',Label:'90 días'}
						]});
						this.ListaDetallesCopia.push({Monto:0,TipoPago:'',Lista:[
							{Valor:'1',Label:'Anticipo'},
							{Valor:'3',Label:'Contraentrega'},
							{Valor:'4',Label:'30 días'},
							{Valor:'5',Label:'60 días'},
							{Valor:'6',Label:'90 días'}
						]});
					}
				}	
			}
			else if (this.Venta.NumPagos==5){
				for (let index = 0; index < 6; index++){
					this.ListaDetalles.push({Monto:0,FechaEstimada:''});
				}
			}
			else{
				this.ListaDetalles.push({Monto:0,TipoPago:''})
			}
		},
		SubirArchivo(){
			const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.NombreArchivo=image.name;
		},
		AbrirContrato(TipoContrato){
			this.bus.$emit('SetContrato',this.Venta.Contrato,this.Venta.IdConfigS,TipoContrato,this.Venta.SpendPlan,this.Venta.IdCotizacionServicio,this.Venta.ValorVenta);
		},
		InputValorCopia(IndexSeleccion){
			this.ListaDetallesCopia[IndexSeleccion].Monto=this.ListaDetalles[IndexSeleccion].Monto;
		},
		LimpiarSpendPlan(){
			this.SpendPlan=[];
		},
		SeleccionPago(IndexSeleccion){
			this.ListaDetallesCopia[IndexSeleccion].TipoPago=this.ListaDetalles[IndexSeleccion].TipoPago;
			this.ListaDetalles=JSON.parse(JSON.stringify(this.ListaDetallesCopia));
			let Index30Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='4');
			let Index60Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='5');
			let Index90Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='6');
			let IndexAnticipo=this.ListaDetalles.findIndex((value) => value.TipoPago=='1');
			// console.log(Index30Dias);
			// console.log(Index60Dias);
			// console.log(Index90Dias);
			for (let i = 0; i < this.ListaDetalles.length; i++) {
				if (Index30Dias!=-1) {
					if (i!=Index30Dias) {
						this.ListaDetalles[i].Lista.splice(2,1);
					}
				}
				if (Index60Dias!=-1) {
					if (Index30Dias!=-1) {
						if (i!=Index60Dias && i!=Index30Dias) {
							this.ListaDetalles[i].Lista.splice(2,1);	
						}
					}
					else{
						if (i!=Index60Dias) {
							this.ListaDetalles[i].Lista.splice(3,1);
						}
					}
				}
				if (Index90Dias!=-1) {
					// console.log(Index30Dias);
					if (i!=Index90Dias) {
						this.ListaDetalles[i].Lista.splice(4,1);
						if (i!=Index30Dias && i!=Index60Dias) {
							this.ListaDetalles[i].Lista.splice(2,2);
						}
						if (Index60Dias!=-1 && Index60Dias>Index90Dias) {
							this.ListaDetalles[Index60Dias].TipoPago='';
						}
					}
				}
				if (IndexAnticipo!=-1 && this.ListaDetalles[i].TipoPago!='1') {
					this.ListaDetalles[i].Lista.splice(0,1);
				}
				let Mapeado=this.ListaDetalles[i].Lista.map((value) => {return value.Valor});
				if (!Mapeado.includes(this.ListaDetalles[i].TipoPago)) {
					this.ListaDetalles[i].TipoPago='';
				}
			}
		},
		GetContratosMaster(){
			this.$http.get('numcontratoadicional/get',{
				params:{
					IdClienteS:this.Venta.IdClienteS
				}
			}).then((res)=>{
				this.ListaContratosMaster=res.data.data.row;
			});
		},
		SetCasillaSpendPlan(){
			if (this.Venta.IdConfigS=="1" || this.Venta.IdConfigS=="3") {
				this.Venta.SpendPlan="2";
			}
			else if(this.Venta.IdConfigS=="2" && this.Venta.IdCotizacionServicio==""){
				this.Venta.SpendPlan="2";
			}
			else{
				this.Venta.SpendPlan="1";
			}
			this.LimpiarSpendPlan();
		},
		SugerenciaVenta(){
            // this.Activo.CodigoActivo=this.CodigoActivo;
			// console.log(this.Venta.ValorPropuesta);
			let ValorPropuesta=this.Venta.ValorPropuesta.toString();
            let substr=ValorPropuesta.substring(0,(ValorPropuesta.length)-1);
            let pattern=new RegExp(substr,"gi");
        
            if (pattern.test(this.Venta.ValorVenta)) {
                this.Venta.ValorVenta=this.Venta.ValorPropuesta;
            }
        },
		SugerenciaPegado(event){
            // console.log(event.clipboardData.getData('text/plain'));
            this.Venta.ValorVenta=event.clipboardData.getData('text/plain');
        },
	},
	created() {
		this.bus.$off('AsignarPropuesta');
		this.bus.$on('AsignarPropuesta',(Propuesta)=>{
			// console.log(Propuesta);
			this.Venta.IdPropuesta=Propuesta.propuesta.IdPropuesta;
			this.GetPropuestas(Propuesta);
		});
		//SPEND PLAN
		this.bus.$off('GuardarSpendPlan');
		this.bus.$on('GuardarSpendPlan',(SpendPlan)=>{
			this.SpendPlan=SpendPlan;
			// console.log(this.SpendPlan);
		});

		this.bus.$off('SeleccionarCliente');
		this.bus.$on('SeleccionarCliente',(oSucursal,oCliente)=>
        {
           this.SeleccionarCliente(oSucursal,oCliente);
        });
		this.bus.$off("NewModal_"+this.EmitSeccion);
		this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id)=>{
			this.poBtnSave.disableBtn = false;
			// this.GetVendedor();
			this.bus.$off("Save_"+this.EmitSeccion);
			this.bus.$on("Save_"+this.EmitSeccion, (Contrato,SpendPlan,TipoContrato,GPPlanPorcent) => {
				this.Venta.Contrato=Contrato;
				this.SpendPlan=SpendPlan;
				this.TipoContrato=TipoContrato;
				if (this.Venta.SpendPlan==1) {
					if (this.Venta.IdCotizacionServicio>0) {
						this.Venta.GrossProfit=GPPlanPorcent;
					}
				}
				this.GPPlanPorcent=GPPlanPorcent;
				this.Guardar();
			});
			this.Limpiar();
			this.GetVendedor();
			if (Id > 0) {
				this.Venta.IdVenta = Id;
				this.get_one();
			}
		});
	},
	computed:{
		typeCalendar: function() {
			return "single";
		},
	}
}
</script>

<style>

</style>
